export enum AgendaStatus{
    noAgendas = 0,
    hasAbsence=1,
    homeOffice=2
}
